/**
 * @description Directory for ID Attributes on PieChart.
 * Naming Convention: "data-test-id-[VIEW/COMPONENT]-[ELEMENT]-[NAME]".
 * Example: id = "data-test-id-mainlayout-btn-cancel".
 */
const idDirectory = {
    divContainer: `piechart-div-container`,
    divChart: `piechart-div-chart`,
    divNoData: `piechart-div-noData`,
    divLoading: `piechart-div-loading`,
 
}

export default idDirectory
